import { pmToMd } from './mappings';
export var filterSchemaMapping = function filterSchemaMapping(schema, map) {
  return Object.keys(map).reduce(function (newMap, key) {
    var value = map[key];
    var block = value.block || value.node;
    var mark = value.mark;
    if (block && schema.nodes[block] || mark && schema.marks[mark]) {
      newMap[key] = value;
    }
    return newMap;
  }, {});
};
export var enableSchemaPlugins = function enableSchemaPlugins(md, schema) {
  for (var k in pmToMd) {
    var key = k;
    for (var i in pmToMd[key]) {
      var idx = i;
      if (schema[key][idx]) {
        md.enable(pmToMd[key][idx]);
      }
    }
  }
};